/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationPostureRequest {
    getFixupPrototypeFunction() { return OperationPostureRequest.fixupPrototype; }

    static newInstance(model: Partial<OperationPostureRequest>): OperationPostureRequest {
        let obj = Object.assign(new OperationPostureRequest(), model);
        OperationPostureRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationPostureRequest>): OperationPostureRequest {
        if (!model) return null;
        return OperationPostureRequest.newInstance(<OperationPostureRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationPostureRequest) {
        if (!obj) return;

        models.OperationPostureRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationPostureRequest): boolean {
        Object.setPrototypeOf(obj, OperationPostureRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.limit === undefined) {
            this.limit = 0;
        }
        if (this.page === undefined) {
            this.page = 0;
        }
    }

    /**
     * to filter data by cloud provider or cloud account wise or tenant.By default tenant wise data displayed
     */
    filter_by: models.OperationPostureFilter;

    /**
     * Specify the tenant ID. This is a unique ID and can be retrieved using the List Tenants API.
     */
    tenant_ids: string;

    /**
     * select the cloud account type
     */
    service_name: models.CloudServiceName;

    /**
     * Limit
     */
    limit: number;

    /**
     * Page
     */
    page: number;

    /**
     * Search by account_name wise
     */
    search: string;

}
